module.exports = __webpack_public_path__ + "media/assets/youtupe-28bcad582af50ae424398a44ac0b89ed.svg";